import React from 'react';
import BookingTicket from '../Ticket/BookingTicket';
import { useSelector } from 'react-redux';
import { orderSelector } from '../../../store/feature/orderSlice';
import { get_dynamic_styles } from '../../../constant/DynamicStyles';

const DynamicTicketList = ({ data, styles }) => {
  const { order_details } = useSelector(orderSelector);
  const ticket_list =
    order_details?.order_details?.[0]?.order_detail_item_attributes;

  return (
    <div
      id="dynamic_ticket_list"
      style={{
        display: styles?.main_styles?.display,
        ...get_dynamic_styles(styles?.main_styles),
      }}
    >
      {ticket_list?.map((ticket) => {
        return (
          <BookingTicket
            order_details={order_details}
            order_item={order_details?.order_details?.[0]}
            ticket_attribute={ticket}
            isShowButtons={data?.is_show_buttons ?? false}
          />
        );
      })}
    </div>
  );
};

export default DynamicTicketList;
